import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLvtAccountSettings extends SnModel {
  @Expose()
  public accountName: string;

  @Expose()
  public clientId: string;

  @Expose()
  public secretKey: string;

  @Expose()
  public enableWebhook: boolean;

  @Expose()
  public webhookId: string;

  @Expose()
  public webhookUrl: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
